class FormRuleChain {
    Id: number;
    FormRuleId: number;
    Conjunction: string;
    DataName: string;
    Operator: string;
    ValueMatch: string;
    Sequence: number;

    constructor(id: number, formRuleId: number, conjunction: string, dataName: string, operator: string, valueMatch: string, sequence: number) {
        this.Id = id;
        this.FormRuleId = formRuleId;
        this.Conjunction = conjunction;
        this.DataName = dataName;
        this.Operator = operator;
        this.ValueMatch = valueMatch;
        this.Sequence = sequence;
    }
}

export default FormRuleChain;